import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import EventsListPage from '../../page/EventsListPage';
import store from '../../configureStore';
import * as frameActions from '../../actions/frames';
import * as settingActions from '../../actions/settings';
import { getTimeFrameFromDate } from '../../utilities/timeUtility';
import { getIntOrDefault } from '../../utilities/conversionUtility';
import ComponentWidgetContainer from '../ComponentWidgetContainer';

export default class EventsListWidgetContainer extends ComponentWidgetContainer {
  componentDidMount() {
    const {
      exceededBookingsLimit,
      exceededTrialPlan,
      product: { resources },
      rescheduleBookingResources,
      settings: { setting },
    } = this.props;

    const { timeZone } = window.bta;
    const today = new Date();
    const maxMonth = getIntOrDefault(setting.max_number_of_months, 6);
    const { start, finish } = getTimeFrameFromDate(today, timeZone, maxMonth);
    let resourceId = null;

    if (rescheduleBookingResources) {
      resourceId = resources.find((resource) => resource.id === rescheduleBookingResources[0])?.id;
    }

    if (!exceededBookingsLimit && !exceededTrialPlan) {
      store
        .dispatch(
          frameActions.fetchFrames({
            start: start.format(),
            finish: finish.format(),
            location_id: this.location?.id,
            resource_id: resourceId,
            isEventsList: true,
          }),
        );
    }

    super.componentDidMount();
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <EventsListPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = (value) => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation({ key, value }));
};
window.changeSetting = (key, value) => store.dispatch(settingActions.setSetting({ key, value }));

EventsListWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
};
